$.fn.dxCtrlSaisieCbMyPos = function custom_dxCtrlSaisieCbMyPos(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlsaisiecbmypos");
        this.instance = new cdxCtrlSaisieCbMyPos(this, option);
    }
    return this;
}
window.cdxCtrlSaisieCbMyPos = function (container, option) {
    var Me = this;
    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }
    // Origine ou est heberge myPos.html -- doit correspondre exactement a
    // "URL du site Web" enregistree chez myPOS.
    var ORIGINE_WIDGET_MYPOS = "https://config.popsoft.fr"
    // "?v=" + parametre.version : anti-cache, pour etre sur que le navigateur
    // recharge bien la derniere version deployee du fichier a chaque changement.
    var URL_WIDGET_MYPOS = "https://config.popsoft.fr/ext/myPos.html?v=" + parametre.version;
    var URL_HANDLER_MYPOS = "https://config.popsoft.fr/ext/HandlerMyPos.ashx";
    var $DivButtonPayer = null;
    var idDivMyposContainer = "mypos-embedded-checkout"
    var $iframeMyPos = null;
    var formulaireIframePret = false;
    // Reference vers l'ecouteur "message" en cours, pour pouvoir le retirer
    // avant d'en recreer un (evite les doublons si l'ancienne iframe n'etait
    // pas encore detruite).
    var ecouteurMessagesActuel = null;
    // Timeout de "filet de securite" -- voir demarrerTimeoutVerificationForcee.
    var timeoutVerificationForcee = null;
    // Garde-fou anti-boucle : si le paiement echoue en continu (ex: erreur
    // systemique cote myPOS), on ne relance PAS indefiniment tout seul --
    // au bout de MAX_ECHECS_AVANT_ARRET essais automatiques, on s'arrete et on
    // laisse la main a l'utilisateur (bouton "Reessayer" manuel).
    var nbEchecsConsecutifs = 0;
    var MAX_ECHECS_AVANT_ARRET = 1;

    function mBindClickPayer() {
        $DivButtonPayer.off("click").on("click", function (e) {
            e.preventDefault();
            if ($DivButtonPayer.is(":hidden")) return; // garde-fou anti double-clic
            $DivButtonPayer.hide();
            jaugeDemarrage.mShow()
            // On ne peut pas appeler payment.processPayment() directement (l'objet
            // vit dans l'iframe, autre origine) -- on demande a l'iframe de le faire.
            if ($iframeMyPos && formulaireIframePret) {
                $iframeMyPos[0].contentWindow.postMessage({ type: "mypos-process-payment" }, ORIGINE_WIDGET_MYPOS)
                demarrerTimeoutVerificationForcee()
            }
        });
    }

    function mConstruit() {
        // Nettoyage explicite de l'ancienne iframe/ecouteur AVANT de
        // reconstruire -- sinon l'ancienne instance de myPos.html peut rester
        // vivante et recevoir un second "mypos-init" en plus de la nouvelle
        // (observe : deux formulaires IPC empiles dans le meme
        // #mypos-embedded-checkout).
        annulerTimeoutVerificationForcee()
        if (ecouteurMessagesActuel) {
            window.removeEventListener("message", ecouteurMessagesActuel)
            ecouteurMessagesActuel = null
        }
        if ($iframeMyPos) {
            $iframeMyPos.off()
            $iframeMyPos.remove()
            $iframeMyPos = null
        }

        container.empty()
        var containerForm = $("<form id='payment-form-mypos'/>").appendTo(container)
        var $DivInformation = $('<div id="information"></div>').appendTo(containerForm)

        $iframeMyPos = $('<iframe id="' + idDivMyposContainer + '" style="width:100%;min-height:400px;border:0;"></iframe>').appendTo($DivInformation)

        $DivButtonPayer = $('<button type="button" id="submit" class="buttonstripe">').appendTo(containerForm)
        $DivButtonPayer.prop("disabled", true)
        $('<div class="spinner hidden" id="spinner"></div>').appendTo($DivButtonPayer)
        $('<span id="button-text">Payer</span>').appendTo($DivButtonPayer)
        $('<div id="payment-message" class="hidden"></div>').appendTo(containerForm)

        mGetCheckout(function (data) {
            $("#button-text").html("Payer <b>" + (option.amount100 / 100).round().formatDisplay() + "€</b>")

            var paymentParams = {
                sid: data.sid,
                walletNumber: data.wallet_number,
                keyIndex: parseInt(data.key_index, 10),
                amount: parseFloat(data.amount), // Number JS requis, pas une chaine
                currency: data.currency,
                orderID: data.order_id, // "orderID" (D majuscule), nom exact du SDK
                urlNotify: URL_HANDLER_MYPOS,
                urlOk: window.location.href,
                urlCancel: window.location.href,
                ipcLanguage: "fr",
                cartItems: [{
                    article: data.description,
                    quantity: 1,
                    price: parseFloat(data.amount),
                    currency: data.currency
                }],
                // false = environnement de PRODUCTION myPOS (coherent avec
                // SANDBOX_MYPOS_ACTIF = False cote serveur, cHandlerInterneMyPos.vb,
                // qui valide deja ces memes identifiants contre l'URL de prod).
                isSandbox: false
            }

            $DivButtonPayer.prop("disabled", true)
            mInitialiserWidgetViaIframe(paymentParams)

            window.setTimeout(function () {
                $("#payment-form-mypos").animate({ opacity: 1 }, 400, function () {
                    if (typeof option.onContentReady != 'undefined') option.onContentReady()
                })
            }, 200)
            mBindClickPayer();
        })
    }

    function mInitialiserWidgetViaIframe(paymentParams) {
        formulaireIframePret = false

        function ecouteurMessages(event) {
            if (event.origin !== ORIGINE_WIDGET_MYPOS) return
            if (!event.data || typeof event.data.type === 'undefined') return

            switch (event.data.type) {
                case "mypos-form-ready":
                    formulaireIframePret = true
                    $DivButtonPayer.prop("disabled", false)
                    break
                case "mypos-form-error":
                    mSaveError(JSON.stringify({ type: "createPaymentForm_rejected", err: event.data.error }))
                    mEchecPaiement("Impossible d'initialiser le formulaire de paiement myPOS.")
                    break
                case "mypos-event":
                    handleResponse(event.data.eventType, event.data.body)
                    break
            }
        }
        ecouteurMessagesActuel = ecouteurMessages
        window.addEventListener("message", ecouteurMessages)

        $iframeMyPos.on("load", function () {
            $iframeMyPos[0].contentWindow.postMessage({
                type: "mypos-init",
                paymentParams: paymentParams
            }, ORIGINE_WIDGET_MYPOS)
        })

        $iframeMyPos.attr("src", URL_WIDGET_MYPOS)
    }

    this.mClickButtonPayer = function () {
        $DivButtonPayer.trigger("click")
    }

    function mRafraichirCheckoutPuisReafficher() {
        jaugeDemarrage.mHide()
        mConstruit() // recree tout le formulaire avec un order_id neuf
    }

    // Garde-fou : le SDK myPOS ne remonte pas systematiquement onError (ex:
    // erreur affichee dans son iframe interne IPCIFrame, sans notification JS
    // -- observe avec E_IPC_ERROR). Si on ne recoit ni succes ni erreur dans
    // un delai raisonnable apres le clic sur "Payer", on verifie quand meme le
    // statut reel cote serveur plutot que de rester bloque indefiniment.
    function demarrerTimeoutVerificationForcee() {
        annulerTimeoutVerificationForcee()
        timeoutVerificationForcee = window.setTimeout(function () {
            mConfirmCheckout(function (data) {
                if (data.status == "PAID") {
                    nbEchecsConsecutifs = 0
                    jaugeDemarrage.mHide()
                    option.onValidePaiement(option.amount100, data)
                } else {
                    mEchecPaiement("Le paiement n'a pas pu être confirmé.")
                }
            })
        }, 15000) // a ajuster selon le temps normal d'un paiement reussi
    }

    function annulerTimeoutVerificationForcee() {
        if (timeoutVerificationForcee) {
            window.clearTimeout(timeoutVerificationForcee)
            timeoutVerificationForcee = null
        }
    }

    // Point d'entree UNIQUE pour tout echec de paiement (erreur SDK, timeout
    // de verification forcee, statut confirme non-PAID...). Compte les echecs
    // consecutifs et n'auto-relance que jusqu'a MAX_ECHECS_AVANT_ARRET -- au-
    // dela, on affiche une erreur definitive et on attend une action manuelle
    // de l'utilisateur, pour ne jamais boucler indefiniment sur une erreur
    // systemique.
    function mEchecPaiement(messageAffiche) {
        $DivButtonPayer.hide().prop("disabled", true) // jamais de bouton actif a cote d'un echec constate
        nbEchecsConsecutifs++
        //mNotify(messageAffiche + (nbEchecsConsecutifs > 1 ? " (tentative " + nbEchecsConsecutifs + ")" : ""), "error", 6000)
        if (nbEchecsConsecutifs >= MAX_ECHECS_AVANT_ARRET) {
            mAfficherEchecDefinitif()
        } else {
            mRafraichirCheckoutPuisReafficher()
        }
    }

    // container.empty() volontairement absent ici (contrairement a
    // mRafraichirCheckoutPuisReafficher) : l'iframe reste affichee telle
    // quelle, avec le message d'erreur que myPOS y a lui-meme rendu.
    function mAfficherEchecDefinitif() {
        jaugeDemarrage.mHide()
        if ($(".mypos-echec-definitif", container).length > 0) return // deja affiche, pas de doublon
        var $Div = $('<div class="mypos-echec-definitif"></div>').appendTo(container)
        $("<p style='color:red;'>Le paiement n\'a pas pu aboutir" + (nbEchecsConsecutifs > 1 ? " après plusieurs tentatives" : ".") + "</p>").appendTo($Div)
        $("<div/>").appendTo($Div).dxCtrlButton({
            text: "Réessayer",
            onClick: function (e) {
                nbEchecsConsecutifs = 0
                mConstruit() // la, on reconstruit vraiment tout
            }
        })
    }

    function handleResponse(type, body) {
        annulerTimeoutVerificationForcee() // un vrai evenement est arrive, plus besoin du filet de securite
        switch (type) {
            case "success":
                // "success" ici veut dire "le formulaire a ete accepte par
                // myPOS", PAS que le paiement est definitivement confirme --
                // on revérifie TOUJOURS cote serveur (mConfirmCheckout).
                mConfirmCheckout(function (data) {
                    if (data.status == "PAID") {
                        nbEchecsConsecutifs = 0
                        jaugeDemarrage.mHide()
                        option.onValidePaiement(option.amount100, data)
                    } else {
                        mSaveError(JSON.stringify({ type: type, body: body, status: data.status }))
                        mEchecPaiement("Paiement non confirmé (" + data.status + ").")
                    }
                })
                break
            case "error":
                mSaveError(JSON.stringify({ type: type, body: body }))
                mEchecPaiement("Le paiement a echoué ou a été annulé.")
                break
            case "message":
                mSaveError(JSON.stringify({ type: type, body: body }))
                break
        }
    }

    function mGetCheckout(funcOk, funcAlways) {
        option.bddCtrl.mAjaxCall({
            command: "getcbcheckoutmypos",
            id_table: option.id_table,
            id: option.id,
            id_societe: option.id_societe,
            amount100: option.amount100
        }, function (data) {
            if (typeof data.text_erreur != 'undefined') {
                if (typeof option.onErrorPaiement != 'undefined') option.onErrorPaiement(data.text_erreur)
            } else {
                funcOk(data)
            }
        },
            function () { if (typeof funcAlways != 'undefined') funcAlways() },
            function (a, b, c, d) {
                if (typeof option.onErrorPaiement != 'undefined') option.onErrorPaiement("")
                if (typeof funcAlways != 'undefined') funcAlways()
            })
    }

    var inCallConfirmCheckOut = false
    function mConfirmCheckout(funcOk) {
        if (inCallConfirmCheckOut) return
        inCallConfirmCheckOut = true
        option.bddCtrl.mAjaxCall({
            command: "confirmcbcheckoutmypos",
            id_table: option.id_table,
            id: option.id,
            id_societe: option.id_societe
        }, function (data) {
            funcOk(data)
        },
            function () { inCallConfirmCheckOut = false },
            function (a, b, c, d) {
                if (typeof option.onErrorPaiement != 'undefined') option.onErrorPaiement("")
            })
    }

    function mSaveError(dataError) {
        try {
            option.bddCtrl.mAjaxCall({ command: "saveerrorcb", dataError: dataError, stacktrace: mGetStackTrace() }, function (data) { })
        }
        catch (e) { }
        try {
            throw new Error("Erreur cb MYPOS (" + JSON.stringify(dataError) + ")");
        } catch (e) {
            mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange", function () { })
        }
    }

    this.element = function () { return container }
    mConstruit();
}